const styles = theme => ({
  pageButtonsWrap: {
    marginBottom: theme.spacing.unit * 4,
  },
});

export default styles;
